import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useOpenLoginModal } from './useOpenLoginModal'
import {
  removeBookmark,
  setBookmark,
} from '@/redux/store/actions/bookmarkActions'

const useBookmarkToggle = id => {
  const dispatch = useDispatch()
  const isLogin = useSelector(
    state => state.bootstrapData?.data?.user_info?.uid,
  )
  const data = useSelector(state => state?.bookmarkReducer?.data)
  const [isBookmarked, setIsBookmarked] = useState(data?.includes(id))
  const { setLoginDrawerState } = useOpenLoginModal()

  const toggleBookmark = () => {
    if (isLogin) {
      if (isBookmarked) {
        sessionStorage.setItem('bookmark_list', '[]')
        dispatch(removeBookmark({ id }))
      } else {
        dispatch(setBookmark({ id }))
      }
    } else {
      sessionStorage.setItem('bookmark_list', `[${id}]`)
      setLoginDrawerState({
        open: true,
        message:
          'برای افزودن اقامتگاه به لیست علاقه‌مندی‌ها لطفا ابتدا وارد حساب کاربری خود شوید.',
      })
    }
  }

  useEffect(() => {
    const lastBookmarks = JSON.parse(
      sessionStorage?.getItem('bookmark_list') || '[]',
    )
    if (lastBookmarks?.includes(id)) {
      if (isLogin) {
        if (!data?.includes(id)) {
          dispatch(setBookmark({ id }))
        }
      }
    }
    setIsBookmarked(data?.includes(id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogin, id, data])

  return { isBookmarked, toggleBookmark }
}

export default useBookmarkToggle
